import React, { useState } from "react";
import Header from "./Header";
import Brand from "./Brand";

const HeaderWithBrand = ({ user, routeGroup, onboardingPercent, isFreeTrial }) => {
  return (
    <>
      <Brand />

      <Header
        user={user}
        onboardingPercent={onboardingPercent}
        routeGroup={routeGroup}
        isFreeTrial={isFreeTrial}
      />
    </>
  );
};

export default HeaderWithBrand;